export default __webpack_public_path__ + "static/media/ic_loading@2x.0114aa6e.gif";